import PropTypes from "prop-types";
import { z } from "zod";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { BaseForm, FormTextarea } from "components/BaseForm";

const parsesAsObject = text => {
  try {
    const value = JSON.parse(text);
    return value !== null && typeof value === "object";
  } catch {
    return false;
  }
};

const schema = z.object({
  design: z
    .string()
    .refine(parsesAsObject, "The design must be a valid JSON object"),
});

/**
 * Raw JSON view of the Unlayer design. Applying loads the design into the
 * editor only; it is persisted when the Graphical tab is saved.
 */
const EditDesignJsonDialog = ({ open, onOpenChange, design, onApply }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="tw:sm:max-w-3xl">
      <DialogHeader>
        <DialogTitle>Edit JSON</DialogTitle>
        <DialogDescription>
          Applying loads this design into the editor. Save the Graphical tab to
          keep it.
        </DialogDescription>
      </DialogHeader>
      <BaseForm
        schema={schema}
        defaultValues={{ design: JSON.stringify(design ?? {}, null, 2) }}
        onSubmit={values => onApply(JSON.parse(values.design))}
        onCancel={() => onOpenChange(false)}
        submitButtonText="Apply"
        submittingButtonText="Applying"
      >
        <FormTextarea
          name="design"
          label="Design"
          rows={20}
          className="tw:max-h-[60vh] tw:font-mono tw:text-xs"
        />
      </BaseForm>
    </DialogContent>
  </Dialog>
);

EditDesignJsonDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  design: PropTypes.object,
  onApply: PropTypes.func.isRequired,
};

export default EditDesignJsonDialog;
